var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section-with-border"},[_vm._t("section-slot")],2)}
var staticRenderFns = []

export { render, staticRenderFns }